import { EventManager as Manager } from "../../utils/eventManager";

export const EventManager = new Manager<string>();